import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import cn from 'classnames';

import styles from './clickable.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export const Clickable = ({
  children,
  disabled,
  className,
  type = 'button',
  ...restProps
}: PropsWithChildren<Props>) => {
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        styles.root,
        { [styles.root_disabled]: disabled },
        className
      )}
      {...restProps}
    >
      {children}
    </button>
  );
};
